import React from 'react';
import { classes } from './PaymentDetails.st.css';
import Text, { TextType } from '../../Text/Text';
import { PaymentOption, PaymentType } from '../../../../types/types';
import { PaymentDetailsDataHooks } from './dataHooks';
import { useExperiments, useTranslation } from '@wix/yoshi-flow-editor';
import { PriceUtils } from '@wix/bookings-uou-mappers';
import { useFormComponentContext } from '../../Hooks/useFormComponentContext';
import { Divider } from '@wix/wix-base-ui';
import { ExperimentsConsts } from '../../../../consts/experiments';

interface PaymentDetailsProps {
  paymentOption: PaymentOption;
  payNowAmount?: number;
  payLaterAmount?: number;
  currency?: string;
}

export const PaymentDetails: React.FC<PaymentDetailsProps> = ({
  paymentOption,
  payNowAmount,
  payLaterAmount,
  currency,
}) => {
  const { label, suffix, validUntil } = paymentOption;
  const { t } = useTranslation();
  const { dateRegionalSettingsLocale } = useFormComponentContext();
  const { experiments } = useExperiments();

  const showPayNow = !!(
    paymentOption.type === PaymentType.USE_PLAN &&
    payNowAmount &&
    payNowAmount > 0
  );
  const showPayLater =
    experiments.enabled(ExperimentsConsts.AddonsWithPlanOnlyUOU) &&
    !!(
      paymentOption.type === PaymentType.USE_PLAN &&
      payLaterAmount &&
      payLaterAmount > 0
    );

  return (
    <div data-hook={PaymentDetailsDataHooks.PAYMENT_DETAILS}>
      <div className={classes.paymentDetails}>
        <Text type={TextType.Secondary}>{label}</Text>
        {suffix ? (
          <Text className={classes.planSlotsLeft} type={TextType.Secondary}>
            {suffix}
          </Text>
        ) : null}
      </div>
      <div>
        <Text type={TextType.Secondary}>{validUntil}</Text>
      </div>
      {showPayNow && (
        <>
          <Divider className={classes.divider} />
          <div
            className={classes.payNowLaterSection}
            data-hook={PaymentDetailsDataHooks.PAY_NOW_SECTION}
          >
            <div className={classes.payNowLaterDetails}>
              <Text type={TextType.Secondary}>
                {t('app.payment.summary.pay-now.label')}
              </Text>
              <Text
                type={TextType.Secondary}
                data-hook={PaymentDetailsDataHooks.PAY_NOW_AMOUNT}
              >
                {PriceUtils.getFormattedCurrency({
                  price: payNowAmount,
                  currency: currency || 'USD',
                  locale: dateRegionalSettingsLocale,
                })}
              </Text>
            </div>
          </div>
        </>
      )}
      {showPayLater && (
        <>
          <Divider className={classes.divider} />
          <div
            className={classes.payNowLaterSection}
            data-hook={PaymentDetailsDataHooks.PAY_LATER_SECTION}
          >
            <div className={classes.payNowLaterDetails}>
              <Text type={TextType.Secondary}>
                {t('app.payment.summary.pay-later.label')}
              </Text>
              <Text
                type={TextType.Secondary}
                data-hook={PaymentDetailsDataHooks.PAY_LATER_AMOUNT}
              >
                {PriceUtils.getFormattedCurrency({
                  price: payLaterAmount,
                  currency: currency || 'USD',
                  locale: dateRegionalSettingsLocale,
                })}
              </Text>
            </div>
          </div>
        </>
      )}
    </div>
  );
};
